@if (domainService.featureFlags()['sideBanner']) {
  <div
    class="side-banner"
    [style.background-color]="themeService.image().bannerColor ?? undefined"
    >
    @if (themeService.image().bannerLogoUrl) {
      <img
        class="side-banner__logo"
        [src]="themeService.image().bannerLogoUrl"
        alt=""
        />
    }
  </div>
} @else {
  <div class="bg-presentation login-height-md">
    <div class="row justify-content-start mb-5">
      <div class="col pt-3 px-4">
        <img
          [src]="themeService.image().presentationLogo"
          alt="Logo Excuela"
          width="200"
          />
        </div>
      </div>
      <div class="row justify-content-center mt-5">
        <div class="col">
          <app-excuela-carousel></app-excuela-carousel>
        </div>
      </div>
    </div>
  }

